/* ============================================================
   free-shipping-bar-refresh.js
   ============================================================
   Standalone, BYTE-EXACT copy of theme.min.js's freeShippingBar(node),
   so the wishlist "Move to bag" flows (wishlist.js / quick-account.js /
   wishlist-account.js) can re-run the free-shipping + gift PROGRESS BAR
   after their manual quick-cart innerHTML swap.

   WHY: organic add-to-cart goes through Stiletto's pipeline, which calls
   refreshQuickCart() -> freeShippingBar(barNode) and fills the bar. The
   wishlist flows hit /cart/add.js raw and swap the drawer HTML by hand,
   which injects a fresh (but UNFILLED, hidden) bar and never runs its JS.
   Stiletto's refresh is behind an internal pub-sub a synthetic DOM event
   can't reach, and theme.min.js is a module so freeShippingBar isn't on
   window. So we keep a verbatim copy here and run it on the swapped bar.

   The function body below is extracted verbatim from assets/theme.js
   (the readable source for theme.min.js). Only the few Stiletto internals
   it referenced (n$2, u$1, r$1, selectors$B, classes$d,
   setGlobalCheckoutButtonState, formatMoney) are shimmed below.

   Exposed as window.rastahRefreshFreeShippingBar(node).
   ============================================================ */
(function () {
  'use strict';

  // querySelector with optional context (Stiletto n$2)
  function n$2(sel, ctx) { return (ctx || document).querySelector(sel); }
  // classList.add(...classes) (Stiletto u$1)
  function u$1(node) { var c = node.classList; c.add.apply(c, [].slice.call(arguments, 1)); }
  // Stiletto pub-sub publish. No-op: the wishlist flow re-renders the
  // drawer itself, and the bar fill below is synchronous. Avoids reaching
  // for an unreachable internal bus.
  function r$1() {}

  var selectors$B = {
    progressBar: ".free-shipping-bar__bar",
    message: ".free-shipping-bar__message",
    stepFreeGift: ".free-shipping-bar__gift",
    stepFreeShipping: ".free-shipping-bar__truck",
    freeShippingProductHeader: ".free-shipping-product__header",
    cartPromotionText: ".quick-cart__footer-promotion-free-gift"
  };
  var classes$d = { loaded: "free-shipping-bar--loaded", success: "free-shipping-bar--success" };

  function setGlobalCheckoutButtonState(disabled) {
    var b = document.querySelector('.quick-cart__submit');
    if (!b) return;
    b.disabled = disabled;
    if (disabled) { b.style.opacity = '0.5'; b.style.cursor = 'not-allowed'; }
    else { b.style.opacity = '1'; b.style.cursor = 'pointer'; }
  }

  // Canonical Shopify money formatter, driven by theme.moneyFormat.
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    function defaultOption(opt, def) { return (typeof opt === 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  // ===== BEGIN verbatim freeShippingBar (extracted from assets/theme.js) =====
  function freeShippingBar(node) {
    const ds = node.dataset;
    
    // ---------------------------------------------------------------------------
    // Gift expiry helpers
    // ---------------------------------------------------------------------------
    const nowMs = Date.now();

    function isExpired(expStr) {
      if (!expStr) return false; // blank = no expiry
      const d = new Date(expStr);
      if (isNaN(d.getTime())) return false;
      return d.getTime() < nowMs;
    }

    // Quantity-based sold out flags coming from Liquid (per market if you wired it that way)
    const gift1SoldOut = ds.gift1SoldOut === 'true' || ds.gift1Inventory === '0';
    const gift2SoldOut = ds.gift2SoldOut === 'true' || ds.gift2Inventory === '0';
    const gift3SoldOut = ds.gift3SoldOut === 'true' || ds.gift3Inventory === '0';
    const gift4SoldOut = ds.gift4SoldOut === 'true' || ds.gift4Inventory === '0';

    // "Expired" = time expiry OR sold out
    const gift1Expired = isExpired(ds.gift1ExpiresAt) || gift1SoldOut;
    const gift2Expired = isExpired(ds.gift2ExpiresAt) || gift2SoldOut;
    const gift3Expired = isExpired(ds.gift3ExpiresAt) || gift3SoldOut;
    const gift4Expired = isExpired(ds.gift4ExpiresAt) || gift4SoldOut;

    const gift1ExpiryDate = ds.gift1ExpiresAt ? new Date(ds.gift1ExpiresAt) : null;
    const gift2ExpiryDate = ds.gift2ExpiresAt ? new Date(ds.gift2ExpiresAt) : null;
    const gift3ExpiryDate = ds.gift3ExpiresAt ? new Date(ds.gift3ExpiresAt) : null;
    const gift4ExpiryDate = ds.gift4ExpiresAt ? new Date(ds.gift4ExpiresAt) : null;

    const messageEl = n$2(selectors$B.message, node);
    const progressBarEl = n$2(selectors$B.progressBar, node);
    const cartPromotionText = document.querySelector(selectors$B.cartPromotionText);

    // ---------------------------------------------------------------------------
    // Normalise cart + thresholds to STORE currency cents
    // ---------------------------------------------------------------------------

    // cart.total_price comes from Liquid as "presentment cents"
    const presentmentCartTotal = parseInt(ds.cartTotal || '0', 10);

    // Shopify.currency.rate = shopCurrency -> presentmentCurrency
    // We want presentment -> shop (store) so we divide
    const rate =
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.rate
        ? window.Shopify.currency.rate
        : 1;

    // cartTotal is now in *store* currency cents
    const cartTotal = rate ? Math.round(presentmentCartTotal / rate) : presentmentCartTotal;

    // helper: parse "250.00" from settings (store currency) -> 25000 store cents
    function toCents(str) {
      if (!str) return 0;
      const num = parseFloat(String(str).replace(',', '.'));
      if (isNaN(num)) return 0;
      return Math.round(num * 100);
    }

    const shippingThresholdCents = toCents(ds.threshold); // free shipping tier
    const gift1ThresholdCents = toCents(ds.giftThreshold);
    const gift2ThresholdCents = toCents(ds.giftThreshold2);
    const gift3ThresholdCents = toCents(ds.giftThreshold3);
    const gift4ThresholdCents = toCents(ds.giftThreshold4);

    // ---------------------------------------------------------------------------
    // Build tier list (shipping + gifts) from data-attributes
    // ---------------------------------------------------------------------------

    const tiers = [];

    function pushTier(type, thresholdKey, labelKey, productKey, options = {}) {
      // If this is a gift and it's expired, don't add it as a tier at all
      if (type === 'gift' && options.expired) return;

      const thresholdStr = ds[thresholdKey];
      const thresholdCents = toCents(thresholdStr); // store cents
      if (!thresholdCents && type !== 'shipping') return; // ignore bad / empty gifts

      const label =
        ds[labelKey] ||
        (type === 'shipping' ? ds.shippingLabel : '') ||
        '';

      const productId =
        productKey && ds[productKey] ? parseInt(ds[productKey], 10) : null;

      const slot = options.slot || 0;
      tiers.push({
        type,           // 'shipping' | 'gift'
        label,          // label for progress bar + nudge
        thresholdCents, // unlock threshold (store cents)
        productId,      // gift variant id or null
        slot,           // 0 = shipping, 1..4 = gift slot (drives data-* lookups)
        title: slot ? (ds['giftTitle' + slot] || label) : label,
        thumb: slot ? (ds['giftThumb' + slot] || '') : '',
        url: slot ? (ds['giftUrl' + slot] || '') : '',
        worth: slot ? (ds['giftWorth' + slot] || '') : ''
      });
    }

    // NOTE: we just push what exists; order will be fixed by sort()
    // `slot` carries the Liquid-emitted slot number so renderRail
    // can grab the right thumb/url/worth/title attributes.
    pushTier('gift',     'giftThreshold',  'giftLabel1', 'freeGiftProduct',  { expired: gift1Expired, slot: 1 });
    pushTier('shipping', 'threshold',      'shippingLabel',                  null,                  { slot: 0 });
    pushTier('gift',     'giftThreshold2', 'giftLabel2', 'freeGiftProduct2', { expired: gift2Expired, slot: 2 });
    pushTier('gift',     'giftThreshold3', 'giftLabel3', 'freeGiftProduct3', { expired: gift3Expired, slot: 3 });
    pushTier('gift',     'giftThreshold4', 'giftLabel4', 'freeGiftProduct4', { expired: gift4Expired, slot: 4 });

    // Remove any empty entries and sort by threshold ascending
    const sortedTiers = tiers
      .filter(t => t.thresholdCents >= 0)
      .sort(function (a, b) {
        return a.thresholdCents - b.thresholdCents;
      });

    // If nothing to do, bail early
    if (!sortedTiers.length) {
      u$1(node, classes$d.loaded);
      return;
    }

    // DOM step nodes
    const stepNodes = node.querySelectorAll('.free-shipping-bar__step');

    // ---------------------------------------------------------------------------
    // Initialisation: messaging, gifts, UI
    // ---------------------------------------------------------------------------

     setMessages();
    setProgressBar();
    syncGiftProducts();
    setActiveSteps();
    setupExpiryCountdown();
    updateUnlockAtLabels();
    renderRail();   // PR-GWP-C: composes focus + status + followup for the conversational rail
    u$1(node, classes$d.loaded);

    // Hide first gift product card entirely if gift 1 is expired
    if (gift1Expired) {
      const firstGiftBlock = node.nextElementSibling;
      if (firstGiftBlock && firstGiftBlock.classList.contains('free-shipping-product')) {
        firstGiftBlock.style.display = 'none';
      }
     
    }
    // setTimeout(() => {
    //   markExpiredGiftRows();
    // }, 100);
    

    // ---------------------------------------------------------------------------
    // Messaging (headline + “Spend X more to unlock {label}”)
    // ---------------------------------------------------------------------------

    function formatCents(cents) {
      // cents are in STORE currency here
      // convert to *presentment* cents using Shopify.currency.rate
      const presentmentCents = Math.round(cents * rate);
      return formatMoney(presentmentCents);
    }

    function setMessages() {
      if (!messageEl) return;

      /*
        PR-GWP-2: one-line headline only. Previously the bar stacked
        "Free shipping unlocked" + "Spend X more to unlock Y" on two
        lines — the step-bar icons already carry the unlocked state
        visually, so the headline should be the FORWARD-LOOKING
        message (next unlock) whenever there's one available, and
        fall back to the success message only when every tier is met.
      */
      const nextTier = sortedTiers.find(t => cartTotal < t.thresholdCents);

      let html = '';
      if (nextTier) {
        const remainder = nextTier.thresholdCents - cartTotal;
        const nudgeTemplate =
          ds.giftNudgeTemplate || 'Spend {{ remaining_amount }} more to unlock {{ label }}.';
        html = nudgeTemplate
          .replace('{{ remaining_amount }}', '<span class="fs-body-bold">' + formatCents(remainder) + '</span>')
          .replace('{{ label }}', nextTier.label || '');
      } else {
        // Everything unlocked — single affirmative line.
        html = ds.freeShippingSuccessMessage || 'You\u2019ve unlocked free shipping';
      }

      messageEl.innerHTML = html;
    }
    function markExpiredGiftRows() {

      console.log('markExpiredGiftRows');
    // scope to the same quick cart / drawer the bar lives in
    const cartRoot = document.querySelector('.cart-freebies__body');

    // Gift 1
    if (cartRoot && gift1Expired) {
      const row1 = cartRoot.querySelector('[data-free-gift-row="1"]');
      if (row1) row1.classList.add('is-expired');
    }

    // Gift 2
    if (cartRoot && gift2Expired) {
      const row2 = cartRoot.querySelector('[data-free-gift-row="2"]');
      if (row2) row2.classList.add('is-expired');
    }

    // Gift 3
    if (cartRoot && gift3Expired) {
      const row3 = cartRoot.querySelector('[data-free-gift-row="3"]');
      if (row3) row3.classList.add('is-expired');
    }

    // Gift 4 (if you’ve added it in the list)
    const gift4Expired = isExpired(ds.gift4ExpiresAt);
    if (cartRoot && gift4Expired) {
      const row4 = cartRoot.querySelector('[data-free-gift-row="4"]');
      if (row4) row4.classList.add('is-expired');
    }
  }
    // ---------------------------------------------------------------------------
    // Expiry countdown message in the bar (APPENDS, does not replace messages)
    // ---------------------------------------------------------------------------
    function updateUnlockAtLabels() {
      // Scope to the same cart drawer this bar is in
      const cartRoot = node.closest('.quick-cart') || document;

      function updateRow(rowNum, thresholdCents) {
        if (!thresholdCents) return;

        const row = cartRoot.querySelector('[data-free-gift-row="' + rowNum + '"]');
        if (!row) return;

        // If it’s already unlocked, don’t change its “Added” label
        if (row.classList.contains('cart-freebies__item--unlocked')) return;

        const statusEl = row.querySelector('.cart-freebies__status');
        if (!statusEl) return;

        statusEl.innerHTML = 'Unlock at ' + formatCents(thresholdCents);
      }

      // Gift #1 is the waitlist gift – leave its text alone

      updateRow(2, gift2ThresholdCents);
      updateRow(3, gift3ThresholdCents);
      updateRow(4, gift4ThresholdCents);
      // markExpiredGiftRows();
    }
    function setupExpiryCountdown() {
      /*
        PR-GWP-2: countdown lives on the specific gift row, not
        appended to the progress-bar message. Render a "Expires in
        Xd Yh" line into `[data-gift-expiry]` inside the gift-row
        partial — gives the countdown direct context (attached to
        the gift it's about) and keeps the progress-bar headline
        free for the next-tier nudge.

        Kill any legacy wrapper in messageEl if it's still present
        from a prior render (section-refresh path).
      */
      const now = Date.now();

      const legacy = messageEl && messageEl.querySelector('.free-shipping-bar__expiry-wrapper');
      if (legacy) legacy.remove();

      const cartRoot = node.closest('.quick-cart, .cart, .purchase-confirmation-popup') || document;

      function formatDiff(ms) {
        const totalSeconds = Math.floor(ms / 1000);
        if (totalSeconds <= 0) return '0s';
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        if (days > 0) return days + 'd ' + hours + 'h';
        if (hours > 0) return hours + 'h ' + minutes + 'm';
        const pad = seconds < 10 ? '0' + seconds : seconds;
        return minutes + 'm ' + pad + 's';
      }

      function bindRow(index, expiryDate) {
        const row = cartRoot.querySelector('[data-free-gift-row="' + index + '"]');
        if (!row) return;
        const target = row.querySelector('[data-gift-expiry]');
        if (!target) return;
        target.classList.remove('hidden');
        function tick() {
          const diff = expiryDate.getTime() - Date.now();
          if (diff <= 0) {
            target.textContent = 'Expired';
            target.classList.add('is-expired');
            return;
          }
          target.textContent = 'Expires in ' + formatDiff(diff);
        }
        tick();
        setInterval(tick, 1000);
      }

      // Bind countdowns per-row for each unlocked + dated tier.
      if (gift1ExpiryDate && !gift1Expired && gift1ThresholdCents && cartTotal >= gift1ThresholdCents && gift1ExpiryDate.getTime() > now) {
        bindRow(1, gift1ExpiryDate);
      }
      if (gift2ExpiryDate && !gift2Expired && gift2ThresholdCents && cartTotal >= gift2ThresholdCents && gift2ExpiryDate.getTime() > now) {
        bindRow(2, gift2ExpiryDate);
      }
      if (gift3ExpiryDate && !gift3Expired && gift3ThresholdCents && cartTotal >= gift3ThresholdCents && gift3ExpiryDate.getTime() > now) {
        bindRow(3, gift3ExpiryDate);
      }
      if (gift4ExpiryDate && !gift4Expired && gift4ThresholdCents && cartTotal >= gift4ThresholdCents && gift4ExpiryDate.getTime() > now) {
        bindRow(4, gift4ExpiryDate);
      }
    }

    // ---------------------------------------------------------------------------
    // Tick marks / filled icons + .done/.done2/.done3/.done4
    // ---------------------------------------------------------------------------

    function setActiveSteps() {
      const shipStep = node.querySelector('.free-shipping-bar__step.free-shipping-bar__truck');
      const giftSteps = node.querySelectorAll('.free-shipping-bar__step.free-shipping-bar__gift');

      const shippingUnlocked =
        !shippingThresholdCents || cartTotal >= shippingThresholdCents;

      const gift1Unlocked =
        !gift1Expired && !!gift1ThresholdCents && cartTotal >= gift1ThresholdCents;

      const gift2Unlocked =
        !gift2Expired && !!gift2ThresholdCents && cartTotal >= gift2ThresholdCents;

      const gift3Unlocked =
        !gift3Expired && !!gift3ThresholdCents && cartTotal >= gift3ThresholdCents;

      const gift4Unlocked =
        !gift4Expired && !!gift4ThresholdCents && cartTotal >= gift4ThresholdCents;

      // Shipping step filled state
      if (shipStep) {
        shipStep.classList.toggle('filled', shippingUnlocked);
      }

      // Gift step 1
      if (giftSteps[0]) {
        if (gift1Expired) {
          giftSteps[0].style.display = 'none';
          giftSteps[0].classList.remove('filled');
        } else {
          giftSteps[0].style.removeProperty('display');
          giftSteps[0].classList.toggle('filled', gift1Unlocked);
        }
      }

      // Gift step 2
      if (giftSteps[1]) {
        if (gift2Expired) {
          giftSteps[1].style.display = 'none';
          giftSteps[1].classList.remove('filled');
        } else {
          giftSteps[1].style.removeProperty('display');
          giftSteps[1].classList.toggle('filled', gift2Unlocked);
        }
      }

      // Gift step 3
      if (giftSteps[2]) {
        if (gift3Expired) {
          giftSteps[2].style.display = 'none';
          giftSteps[2].classList.remove('filled');
        } else {
          giftSteps[2].style.removeProperty('display');
          giftSteps[2].classList.toggle('filled', gift3Unlocked);
        }
      }

      // Gift step 4
      if (giftSteps[3]) {
        if (gift4Expired) {
          giftSteps[3].style.display = 'none';
          giftSteps[3].classList.remove('filled');
        } else {
          giftSteps[3].style.removeProperty('display');
          giftSteps[3].classList.toggle('filled', gift4Unlocked);
        }
      }

      // Promotion badge under subtotal
      if (cartPromotionText) {
        const anyGiftUnlocked =
          gift1Unlocked || gift2Unlocked || gift3Unlocked || gift4Unlocked;
        cartPromotionText.classList.toggle('hidden', !anyGiftUnlocked);
      }

      // Classes on the bar for CSS to flip titles
      node.classList.toggle('done',  gift1Unlocked);
      node.classList.toggle('done2', gift2Unlocked);
      node.classList.toggle('done3', gift3Unlocked);
      node.classList.toggle('done4', gift4Unlocked);
    }

    // ---------------------------------------------------------------------------
    // PR-GWP-C — Gift rail renderer
    //
    // The rail has three zones populated from `sortedTiers` + cart state:
    //
    //   1. STATUS  (small affirmative line per already-unlocked tier;
    //               "✓ Free shipping · added", "✓ Silk Bandana · added")
    //   2. FOCUS   (nearest-locked tier — thumb + reward-first headline
    //               + worth + expiry + progress fill)
    //   3. FOLLOWUP (collapsed sentence: "Then X at $A and Y at $B.")
    //
    // Edge cases:
    //   • ALL unlocked   → only STATUS renders (all rows as "✓ X · added")
    //   • NONE met       → FOCUS on the cheapest tier, no status
    //   • NO gift tiers  → FOCUS on shipping (fallback to the old headline)
    //   • SOLD OUT gifts are already filtered out of sortedTiers by pushTier
    // ---------------------------------------------------------------------------

    function renderRail() {
      const statusEl   = node.querySelector('[data-gift-status]');
      const focusEl    = node.querySelector('[data-gift-focus]');
      const followupEl = node.querySelector('[data-gift-followup]');
      if (!statusEl || !focusEl || !followupEl) return; // Old layout; rail not emitted.

      // Formatter: presentment money, rounded to nearest whole unit
      // of presentment currency (so FX-converted figures don't read
      // "Rs.64,159.08"), then strip trailing .00 / ,00 for consistency
      // with the rest of the cart.
      function money(cents) {
        const presentmentCents = Math.round(cents * rate);
        // Round to the nearest 100 (whole currency unit).
        const rounded = Math.round(presentmentCents / 100) * 100;
        const txt = formatMoney(rounded);
        return (txt || '').replace(/([0-9])[.,]00(\b|$)/, '$1$2');
      }
      function stripTags(s) {
        const d = document.createElement('div');
        d.innerHTML = s || '';
        return (d.textContent || '').replace(/\s+/g, ' ').trim();
      }

      const unlocked = sortedTiers.filter(function (t) {
        return t.thresholdCents === 0 || cartTotal >= t.thresholdCents;
      });
      const locked = sortedTiers.filter(function (t) {
        return t.thresholdCents > 0 && cartTotal < t.thresholdCents;
      });
      // `locked` is ascending by threshold already (sortedTiers is sorted).
      const focusTier = locked[0] || null;
      const remainingLocked = locked.slice(1);

      // ─── STATUS (unlocked tiers) ─────────────────────────────────────
      if (unlocked.length) {
        const chunks = unlocked.map(function (t) {
          const labelTxt = stripTags(t.type === 'shipping' ? (ds.shippingLabel || 'Free Shipping') : (t.title || t.label || 'Free Gift'));
          // PR-CART-1: "You've unlocked <strong>{name}</strong>" per
          // user direction. Title Case labels. CSS removes the
          // prior uppercase transform so merchandiser-set names
          // display as-is (e.g. "Free Shipping", "The Trinket Keychain").
          // Text wrapped in a single span so the inline-flex `gap` on
          // .gift-rail__status-item only inserts space between the SVG
          // check and the text — NOT between every text node / <strong>
          // / period. Without this, the browser created anonymous flex
          // items for each adjacent text/element pair, putting visible
          // whitespace between "unlocked", "<strong>Free Shipping</strong>",
          // and ".".
          return '<span class="gift-rail__status-item"><svg class="gift-rail__status-check" viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12" fill="none" stroke="currentColor" stroke-width="2"/></svg>' +
                 '<span class="gift-rail__status-item-text">You\u2019ve unlocked <strong>' + labelTxt + '</strong>.</span></span>';
        });
        statusEl.innerHTML = chunks.join('');
        statusEl.classList.remove('hidden');
      } else {
        statusEl.innerHTML = '';
        statusEl.classList.add('hidden');
      }

      // ─── FOCUS (nearest locked tier) ────────────────────────────────
      if (focusTier) {
        const remainder = focusTier.thresholdCents - cartTotal;
        const title  = stripTags(focusTier.title || focusTier.label || 'Free gift');
        const worth  = stripTags(focusTier.worth || '');
        const thumb  = focusTier.thumb || '';
        const url    = focusTier.url || '#';
        const span   = focusTier.thresholdCents || 1;
        const fillPct = Math.max(0, Math.min(100, (cartTotal / span) * 100));

        // Headline flavor: shipping vs. gift. Use the merchandiser-set
        // label / title verbatim (no "the ..." prefix) so brand-set
        // names like "Silk Bandana" or "The Trinket Keychain" both
        // read naturally.
        const leadRemainder = '<span class="gift-rail__focus-amount">' + money(remainder) + '</span>';
        /*
          PR-CART-1: copy updated per merchandiser direction:
            "You're {amount} away from <strong>{gift name}</strong>."
          Gift name wrapped in <strong> per user request. Mixed
          case + period at end reads more like natural language than
          the previous UPPERCASE single-line treatment.
        */
        const headline = focusTier.type === 'shipping'
          ? "You're " + leadRemainder + ' away from <strong>free shipping</strong>.'
          : "You're " + leadRemainder + ' away from <strong>' + title + '</strong>.';

        // Sub: "Worth X" + expiry if present
        const subParts = [];
        if (worth && focusTier.type !== 'shipping') subParts.push('Worth ' + worth);
        // Expiry (per-tier): pull the raw ISO + format inline.
        const expiryTs = focusTier.slot ? ds['gift' + focusTier.slot + 'ExpiresAt'] : '';
        if (expiryTs) {
          const exp = new Date(expiryTs);
          if (!isNaN(exp.getTime()) && exp.getTime() > Date.now()) {
            subParts.push('Expires in <span data-gift-focus-expiry data-gift-focus-expiry-ts="' + expiryTs + '"></span>');
          }
        }

        const focusLink  = focusEl.querySelector('[data-gift-focus-link]');
        const focusImg   = focusEl.querySelector('[data-gift-focus-img]');
        const focusTitle = focusEl.querySelector('[data-gift-focus-title]');
        const focusSub   = focusEl.querySelector('[data-gift-focus-sub]');
        const focusFill  = focusEl.querySelector('[data-gift-focus-fill]');

        if (focusLink) focusLink.setAttribute('href', url);
        if (focusImg) {
          if (thumb) {
            focusImg.setAttribute('src', thumb);
            focusImg.alt = title || '';
            focusImg.parentElement.classList.remove('is-empty');
          } else {
            focusImg.removeAttribute('src');
            focusImg.parentElement.classList.add('is-empty');
          }
        }
        if (focusTitle) focusTitle.innerHTML = headline;
        if (focusSub) focusSub.innerHTML = subParts.join(' · ');
        if (focusFill) focusFill.style.width = fillPct + '%';

        focusEl.classList.remove('hidden');

        // Tick the expiry countdown inside the focus row.
        const expirySpan = focusEl.querySelector('[data-gift-focus-expiry]');
        if (expirySpan) {
          const expTs = expirySpan.getAttribute('data-gift-focus-expiry-ts');
          const expDate = new Date(expTs);
          function fmt(ms) {
            const s = Math.floor(ms / 1000);
            if (s <= 0) return '0s';
            const d = Math.floor(s / 86400);
            const h = Math.floor((s % 86400) / 3600);
            const m = Math.floor((s % 3600) / 60);
            const sec = s % 60;
            if (d > 0) return d + 'd ' + h + 'h';
            if (h > 0) return h + 'h ' + m + 'm';
            return m + 'm ' + (sec < 10 ? '0' + sec : sec) + 's';
          }
          function tick() {
            const diff = expDate.getTime() - Date.now();
            if (diff <= 0) {
              expirySpan.textContent = 'now';
              return;
            }
            expirySpan.textContent = fmt(diff);
          }
          tick();
          setInterval(tick, 1000);
        }
      } else {
        focusEl.classList.add('hidden');
      }

      // ─── TOP-BAR PROGRESS (divider under YOUR CART header) ──────────
      // PR-CART-1: full-width progress bar at top of gift-rail that
      // doubles as the visual divider under the header. Shows progress
      // toward the NEAREST locked tier; fills to 100% when everything
      // is unlocked.
      const topbarFill = node.querySelector('[data-gift-topbar-fill]');
      if (topbarFill) {
        let topPct = 100;
        if (focusTier) {
          const span = focusTier.thresholdCents || 1;
          topPct = Math.max(0, Math.min(100, (cartTotal / span) * 100));
        }
        topbarFill.style.width = topPct + '%';
      }

      // ─── FOLLOWUP (remaining locked tiers collapsed to a sentence) ──
      if (remainingLocked.length) {
        const parts = remainingLocked.map(function (t) {
          const labelTxt = stripTags(t.type === 'shipping' ? (ds.shippingLabel || 'Free shipping') : (t.title || t.label));
          return '<strong>' + labelTxt + '</strong> at ' + money(t.thresholdCents);
        });
        let sentence;
        if (parts.length === 1) {
          sentence = 'Then ' + parts[0] + '.';
        } else if (parts.length === 2) {
          sentence = 'Then ' + parts[0] + ' and ' + parts[1] + '.';
        } else {
          sentence = 'Then ' + parts.slice(0, -1).join(', ') + ', and ' + parts[parts.length - 1] + '.';
        }
        followupEl.innerHTML = sentence;
        followupEl.classList.remove('hidden');
      } else {
        followupEl.innerHTML = '';
        followupEl.classList.add('hidden');
      }
    }

    // ---------------------------------------------------------------------------
    // Progress bar: fill only up to the last unlocked tier
    // ---------------------------------------------------------------------------

    function setProgressBar() {
      if (!progressBarEl) return;

      // `sortedTiers`:
      //  - uses STORE currency cents for `thresholdCents`
      //  - excludes any expired gifts
      const activeTiers = sortedTiers;
      const totalTiers = activeTiers.length;

      if (!totalTiers) {
        progressBarEl.style.setProperty('--progress-width', '0%');
        return;
      }

      /*
        PR-GWP-1: smooth interpolation between tier segments.
        Previously we snapped to `unlockedCount / totalTiers` which
        meant zero visual movement until the next threshold hit.
        Loewe/Acne show gradient progress so the user feels the
        momentum of building toward the next reward.

        Each tier gets an equal segment of the bar; within a tier
        we linearly interpolate from its LOWER bound (the previous
        tier's threshold, or 0) to its UPPER bound (this tier's
        threshold). Once fully unlocked, fraction = 1 for that
        segment.
      */
      let unlockedCount = 0;
      let partialFraction = 0;
      let prevThreshold = 0;

      for (let i = 0; i < activeTiers.length; i++) {
        const tier = activeTiers[i];
        if (tier.thresholdCents === 0 || cartTotal >= tier.thresholdCents) {
          unlockedCount += 1;
          prevThreshold = tier.thresholdCents;
        } else {
          // Partial progress within this tier's segment.
          const span = tier.thresholdCents - prevThreshold;
          if (span > 0) {
            const into = Math.max(0, cartTotal - prevThreshold);
            partialFraction = Math.min(1, into / span);
          }
          break;
        }
      }

      if (unlockedCount > totalTiers) unlockedCount = totalTiers;

      const perTier = 1 / totalTiers;
      const progressFraction = (unlockedCount * perTier) + (partialFraction * perTier);
      const progressPercent = Math.max(0, Math.min(100, progressFraction * 100));
      progressBarEl.style.setProperty('--progress-width', progressPercent + '%');
    }

    // ---------------------------------------------------------------------------
    // Gift product add / remove (respects sortedTiers + expiry)
    // ---------------------------------------------------------------------------

    async function syncGiftProducts() {
      // if (typeof setGlobalCheckoutButtonState === 'function') {
      //   setGlobalCheckoutButtonState(true);
      // }
       setGlobalCheckoutButtonState(true);
      const giftTiers = sortedTiers.filter(function (tier) {
        return tier.type === 'gift' && tier.productId;
      });
      if (
        !giftTiers.length &&
        !ds.freeGiftProduct &&
        !ds.freeGiftProduct2 &&
        !ds.freeGiftProduct3 &&
        !ds.freeGiftProduct4
      ) {
        setGlobalCheckoutButtonState(false);
        return;
      }

      // Collect variant IDs for gifts that are now expired
      const expiredGiftIds = [];
      if (ds.freeGiftProduct && gift1Expired) {
        expiredGiftIds.push(parseInt(ds.freeGiftProduct, 10));
      }
      if (ds.freeGiftProduct2 && gift2Expired) {
        expiredGiftIds.push(parseInt(ds.freeGiftProduct2, 10));
      }
      if (ds.freeGiftProduct3 && gift3Expired) {
        expiredGiftIds.push(parseInt(ds.freeGiftProduct3, 10));
      }
      if (ds.freeGiftProduct4 && gift4Expired) {
        expiredGiftIds.push(parseInt(ds.freeGiftProduct4, 10));
      }

      // Helper: load latest cart and convert total to STORE cents
      async function loadCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Gift sync: failed to load cart');
        return res.json();
      }

      function cartTotalStoreCents(cart) {
        const presentmentCartTotal = cart.total_price; // presentment cents
        return rate ? Math.round(presentmentCartTotal / rate) : presentmentCartTotal;
      }

      let cart;
      try {
        cart = await loadCart();
      } catch (e) {
        console.error(e);
        setGlobalCheckoutButtonState(false);
        return;
      }

      let changed = false;

      // Go tier by tier, always using the latest cart snapshot
      for (const tier of giftTiers) {
        const items = cart.items;
        const currentTotal = cartTotalStoreCents(cart);

        const lineIndex = items.findIndex(function (item) {
          // IMPORTANT: tier.productId MUST be a VARIANT ID
          return item.id === tier.productId;
        });

        const isGiftInCart = lineIndex !== -1;
        const shouldHaveGift = currentTotal >= tier.thresholdCents;

        if (shouldHaveGift && !isGiftInCart) {
          // Add gift once
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: tier.productId, quantity: 1 })
          });

          if (!addRes.ok) {
            console.error('Failed to add gift', tier.productId, await addRes.json());
          } else {
            changed = true;
            cart = await loadCart(); // refresh cart + totals for next tiers
          }
        } else if (!shouldHaveGift && isGiftInCart) {
          // Remove gift completely
          const removeRes = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineIndex + 1, quantity: 0 })
          });

          if (!removeRes.ok) {
            console.error('Failed to remove gift', tier.productId, await removeRes.json());
          } else {
            changed = true;
            cart = await loadCart(); // refresh cart for next tiers
          }
        }
        // not locking quantity at 1 to avoid fighting user actions
      }

      // Remove any expired gifts that are still in the cart
      if (expiredGiftIds.length) {
        cart = await loadCart();
        let items = cart.items;

        for (const gid of expiredGiftIds) {
          const idx = items.findIndex(item => item.id === gid);
          if (idx !== -1) {
            const removeRes = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: idx + 1, quantity: 0 })
            });

            if (!removeRes.ok) {
              console.error('Failed to remove expired gift', gid, await removeRes.json());
            } else {
              changed = true;
              cart = await loadCart();
              items = cart.items;
            }
          }
        }
      }

      if (changed) {
        // Only ping the cart UI if we actually changed something
        r$1('quick-cart:updated');
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        setTimeout(() => {
          setGlobalCheckoutButtonState(false);
        }, 300);
      }else{
        setGlobalCheckoutButtonState(false);
      }
      
    }
  }
  // ===== END verbatim freeShippingBar =====

  // Public entry point for the wishlist "Move to bag" flows.
  window.rastahRefreshFreeShippingBar = function (node) {
    if (!node) return;
    try { freeShippingBar(node); }
    catch (e) { if (window.console) console.warn('[free-shipping-bar-refresh]', e); }
  };
})();
